import { makeNetworkRequest } from "../utils/networkUtils";
import { getObjectValue } from "../utils/utils";
import Site from "./Site";

export default class User {

    defaultProfile = {
        firstName: '',
        lastName: '',
        company: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        isAdmin: false
    };

    defaultProfileErrors = {
        firstNameError: '',
        lastNameError: '',
        companyError: '',
        address1Error: '',
        address2Error: '',
        cityError: '',
        stateError: '',
        zipError: '',
    };

    constructor(auth0Profile) {
        this.prepopulateProfile();
        this.firstName = auth0Profile.given_name;
        this.lastName = auth0Profile.family_name;
        this.sub = auth0Profile.user_id ? auth0Profile.user_id : auth0Profile.sub;
        this.email = auth0Profile.email;
        this.accessToken = auth0Profile.accessToken;
        if(getObjectValue(auth0Profile, "profile")) {
            this.firstName = auth0Profile.profile.firstName ? auth0Profile.profile.firstName : this.firstName;
            this.lastName = auth0Profile.profile.lastName ? auth0Profile.profile.lastName : this.lastName;
            this.company = auth0Profile.profile.company;
            this.address1 = auth0Profile.profile.address1;
            this.address2 = auth0Profile.profile.address2;
            this.city = auth0Profile.profile.city;
            this.state = auth0Profile.profile.state;
            this.zip = auth0Profile.profile.zip;
        }
    };

    populateProfileData = (profile) => {
        Object.keys(this.defaultProfile).forEach((key) => {
            if(getObjectValue(profile, key)) {
                this[key] = profile[key];
            }
        });
    };

    prepopulateProfile = () => {
        Object.keys(this.defaultProfile).forEach((key) => {
            this[key] = this.defaultProfile[key];
        });
    };

    getSites = async () => {
        if(this.sub && this.accessToken) {
            let accessControls = await makeNetworkRequest("get", "/sites", this.accessToken, {});
            // console.log(accessControls);

            if(accessControls) {
                let buckets = accessControls.buckets;
                this.isAdmin = accessControls.isAdmin;
                this.sites = Object.keys(buckets).map((resource_id) => {
                    let resource = buckets[resource_id];
                    let permissions = resource.permissions;
                    let status = resource.status;
                    let owner = resource.owner;
                    let shared = resource.shared;
                    let reportPublished = resource.reportPublished;
                    return new Site("", permissions, status, owner, resource_id, shared, reportPublished);
                });
            }
        }
    };

    checkSitesForSelectedSite = async (siteToLookFor, setSelectedSite) => {
        let wasFound = false;
        await Promise.all(this.sites.map((s) => {
            if(s.slug === siteToLookFor) {
                wasFound = true;
                setSelectedSite(s);
            }
            return true;
        }));
        return wasFound;
    };

    getProfile = async () => {
        if(this.accessToken) {
            let fullEndpoint = `/profile`;
            let response = await makeNetworkRequest("get", fullEndpoint, this.accessToken);
            // console.log(response);
            if(response) {
                this.populateProfileData(response.profile);
                return true;
            } else {
                return false;
            }
        }
    };

    updateProfile = async (updatedProfile) => {
        if(this.accessToken && updatedProfile) {
            let fullEndpoint = `/profile`;
            let postData = {
                "profile": {
                    "firstName": updatedProfile.firstName,
                    "lastName": updatedProfile.lastName,
                    "company": updatedProfile.company,
                    "address1": updatedProfile.address1,
                    "address2": updatedProfile.address2,
                    "city": updatedProfile.city,
                    "state": updatedProfile.state,
                    "zipCode": updatedProfile.zip
                },
                "email": this.email
            };
            let response = await makeNetworkRequest("post", fullEndpoint, this.accessToken, postData);
            // console.log(response);
            if(response) {
                return response;
            } else {
                return false;
            }
        }
    };
};
